import * as React from 'react';

import JobSkillsInput from './job_skills_input';
import ProposeTag from '../propose_tag/propose_tag';
import classNames from 'classnames';

const styles = require('./job_skills_section.module.scss');

export enum SkillCategory {
  MustHave = 0,
  OtherRequired = 1,
  NiceToHave = 2,
}

interface Props {
  categoryId: SkillCategory;
  errors: any;
  formName: string;
  jobId?: number;
  mandatory: boolean;
  maximumNumberOfSkills?: number;
  proposedTags: any; // an array of objects like {id: 10, tag: "Python on Rails"}
  proposeTagDisabled: boolean;
  skills: any; // an array of objects like {id: 1, tag: "Rails", experienceLevel: 1 }
  isBackoffice?: boolean;
  hideSelectedSkillCount?: boolean;
}

interface State {
  errors: any;
  proposedTags: any; // an array of objects like {id: 10, tag: "Python on Rails"}
  skills: any; // an array of objects like {id: 1, tag: "Rails", experienceLevel: 1 }
}

export default class JobSkillsSection extends React.Component<Props, State> {
  label: string;
  fieldName: string;
  fieldNote: string;
  proposeTagComponent: any;

  constructor(props) {
    super(props);
    this.state = {
      ...props,
    };
    switch (props.categoryId) {
      case SkillCategory.MustHave: {
        this.label = 'Must have skills';
        this.fieldName = 'must_have_tag_ids';
        this.fieldNote = '';
        break;
      }
      case SkillCategory.OtherRequired: {
        this.label = 'Other required skills';
        this.fieldName = 'other_required_tag_ids';
        this.fieldNote = `The Other Required are all the other skills that are part of
         what's needed to perform the job, but that you don't want to automatically reject
          candidates who don't have one of them.`;
        break;
      }
      case SkillCategory.NiceToHave: {
        this.label = 'Nice to have skills';
        this.fieldName = 'nice_to_have_tag_ids';
        this.fieldNote = `The Nice to Have are optional skills. They make the difference
         between a 4 and a 5 in the Skills dimension.`;
        break;
      }
      default: {
        this.label = 'ERROR';
        this.fieldName = 'ERROR';
        this.fieldNote = 'ERROR';
        break;
      }
    }
    this.handleCreateProposedTag = this.handleCreateProposedTag.bind(this);
  }

  handleCreateProposedTag(proposedTagName) {
    this.proposeTagComponent.openProposeTagForm(proposedTagName);
  }

  render() {
    const propsProposeTag = {
      jobId: this.props.jobId,
      categoryId: this.props.categoryId,
      formName: this.props.formName,
    };

    const propsJobSkillsInput = {
      ...this.props,
      disableSort: true,
      fieldName: this.fieldName,
      readOnly: false,
      renderSignupVersion: true,
      updateSkills: () => {},
    };

    const showFooterInstruction =
      this.state.skills && this.state.skills.length > 0 && !this.props.hideSelectedSkillCount;

    return (
      <>
        <div className={styles.title}>
          <label className={classNames(styles.label, 'js-field-section-title')}>{this.label}</label>{' '}
          {this.props.mandatory && <span className={styles.mandatory}>*</span>}
        </div>
        {this.fieldNote && <p className='trix-skills-label'>{this.fieldNote}</p>}
        <p className={styles.instructions}>
          {!this.props.proposeTagDisabled && (
            <ProposeTag {...propsProposeTag} ref={ref => (this.proposeTagComponent = ref)} />
          )}
        </p>
        <JobSkillsInput
          {...propsJobSkillsInput}
          createProposedTagCallback={
            this.props.proposeTagDisabled ? null : this.handleCreateProposedTag
          }
          color={this.props.isBackoffice ? 'tuftsBlue' : 'ripePlum'}
        />
        {showFooterInstruction && (
          <p className={classNames('small-instructions', styles.smallInstructions)}>
            Numbers tell you how many users we have with that skill.
          </p>
        )}
      </>
    );
  }
}
